import React from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import { STATUS_META, STATUS_ORDER, pickStatusColor } from './statusMeta';

const DictionaryLegend: React.FC = () => {
  const theme = useTheme();
  return (
    <Stack
      direction={'row'}
      sx={{
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'primary.tableBorder',
        borderRadius: 1.5,
        flexWrap: 'wrap',
        gap: '8px 18px',
        mb: 1.5,
        px: 2,
        py: 1.25,
      }}
    >
      {STATUS_ORDER.map((id) => {
        const m = STATUS_META[id];
        const color = pickStatusColor(id, theme.palette.mode);
        return (
          <Stack
            key={id}
            direction={'row'}
            alignItems={'center'}
            spacing={0.875}
          >
            <Box
              sx={{
                bgcolor: color,
                borderRadius: '50%',
                flex: 'none',
                height: 10,
                width: 10,
              }}
            />
            <Typography sx={{ fontSize: 13, fontWeight: 700 }}>
              {m.label}
            </Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: 12.5 }}>
              {`— ${m.desc}`}
            </Typography>
          </Stack>
        );
      })}
    </Stack>
  );
};

export default DictionaryLegend;
